var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9478_26558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.05229 26.5562C15.237 26.5562 19.2595 23.2806 19.2595 18.3529C19.2595 14.5315 16.8129 12.1032 12.4384 11.0976L9.62977 10.2552C7.16595 9.70206 5.72785 9.0379 6.06668 7.34118C6.34856 5.92965 7.19185 5.1328 9.15285 5.1328C15.3869 5.1328 17.6966 7.34118 17.6966 7.34118V2.02967C17.6966 2.02967 15.4479 0 9.15285 0C3.21957 0 0 3.05297 0 7.77949C0 11.6009 2.23117 13.8233 6.75655 14.8792C7.07327 14.9584 7.23514 14.9991 7.24218 15.0013C7.93052 15.2143 8.85937 15.4958 10.0287 15.8457C12.3417 16.3988 12.9365 16.9858 12.9365 18.7457C12.9365 20.3547 11.2647 21.2693 9.05229 21.2693C2.67899 21.2693 0 18.0452 0 18.0452V23.9299C0 23.9299 1.67531 26.5562 9.05229 26.5562Z",
    fill: "url(#paint0_linear_9478_26558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1794 26.1602C30.3688 26.1602 31.9991 24.5764 31.9991 22.4336C31.9991 20.2442 30.4153 18.707 28.1794 18.707C25.99 18.707 24.4062 20.2442 24.4062 22.4336C24.4062 24.623 25.99 26.1602 28.1794 26.1602Z",
    fill: "#E80000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9478_26558",
    x1: 962.977,
    y1: 0,
    x2: 962.977,
    y2: 2655.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D39FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A380FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9478_26558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 26.625,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo10);
export default __webpack_public_path__ + "static/media/logo10.c77c1696e024274be40628d355669060.svg";
export { ForwardRef as ReactComponent };